export default __webpack_public_path__ + "static/media/payment.e6cfa018.e6cfa018.jpg";